import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { environment } from "src/environments/environment";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { CoreData } from "../tools/core-data/core-data";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoadingTask } from "../tools/loading-task";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class DocumentService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/document`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    addPlanToQualifDocument(file: File, code: string) {
        const formData: FormData = new FormData();

        formData.append('file', file, file.name);

        return this.http.request(new HttpRequest('PUT', `${this.serviceUrl}/AirQF/${code}/Plan`, formData, this.generateHeaderForFormData()))
            .pipe(
                catchError(this.handleError<any>('addPlanToQualifDocument')),
                map((x => x)));
    }

    addMesureTerrainDocument(file: File) {
        const formData: FormData = new FormData();

        formData.append('file', file, file.name);

        return this.http.request(new HttpRequest('PUT', `${this.serviceUrl}/AirQF/mesureTerrain`, formData, this.generateHeaderForFormData()))
            .pipe(
                catchError(this.handleError<any>('addMesureTerrainDocument')),
                map((x => x)));
    }

    overrideReport(file: File, prelevementQualifSalleCode: string) {

        const formData: FormData = new FormData();

        formData.append('file', file, file.name);

        return this.http.request(new HttpRequest('PUT', `${this.serviceUrl}/AirQF/${prelevementQualifSalleCode}/rapport`, formData, this.generateHeaderForFormData()))
            .pipe(
                catchError(this.handleError<any>('overrideReport')),
                map((x => x)));       
    }

    generateReport(prelevementQualifSalleCode: string) {
        this.loadingTask.activateLoading();
        // const body: any = {};
        // if (reason) {
        //     body.reason = reason;
        // }
        return this.http.put(`${this.serviceUrl}/AirQF/${prelevementQualifSalleCode}/rapport/generate`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateReport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean | string) => {
                return response;
            })
        );
    }
    getPlanForQualifSalle(prelevementQualifSalleCode: string) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/AirQF/${prelevementQualifSalleCode}/plan`, this.generateHeaderForBlobDownload()).pipe(
            catchError(this.handleError<any>('getPlanForQualifSalle')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getMesureTerrainForQualifSalle(prelevementQualifSalleCode: string) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/AirQF/${prelevementQualifSalleCode}/mesureTerrain`, this.generateHeaderForBlobDownload()).pipe(
            catchError(this.handleError<any>('getMesureTerrainForQualifSalle')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getReportRawVersion(prelevementQualifSalleCode: string) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/AirQF/${prelevementQualifSalleCode}/rapport/docx`, this.generateHeaderForBlobDownload()).pipe(
            catchError(this.handleError<any>('getReportRawVersion')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getReport(prelevementQualifSalleCode: string) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/AirQF/${prelevementQualifSalleCode}/rapport/pdf`, this.generateHeaderForBlobDownload()).pipe(
            catchError(this.handleError<any>('getReport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}